import { createSearchParameters } from '../utils';
import { getPromoCode } from './promoCode/selectors';
import { getPassengerTypes } from './passengerTypes/selectors';
var getPassengers = function (state) { return state.passengers; };
var getSegments = function (state) { return state.segments; };
export var getRedeemMiles = function (state) { return state.redeemMiles; };
export var getSearchParameters = function (state) {
    return createSearchParameters(getPassengers(state), getSegments(state), getPromoCode(state), getRedeemMiles(state), getPassengerTypes(state));
};
